import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer({ overImage = false }) {
  const linkStyle = { color: 'var(--text-secondary)', fontSize: 12, fontWeight: 600, textDecoration: 'none' };
  return (
    <div style={{
      borderTop: `1.5px solid ${overImage ? 'var(--border-strong)' : 'var(--border)'}`,
      background: overImage ? 'var(--nav-bg)' : 'transparent',
      backdropFilter: overImage ? 'blur(18px)' : 'none',
      WebkitBackdropFilter: overImage ? 'blur(18px)' : 'none',
      padding: '18px 32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
    }}>
      <span style={{ color: 'var(--text-muted)', fontSize: 11, fontWeight: 500 }}>&copy; {new Date().getFullYear()} Shortflix. All rights reserved.</span>
      <div style={{ display: 'flex', gap: 20 }}>
        <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>
        <Link to="/faq" style={linkStyle}>FAQ</Link>
        <Link to="/guidelines" style={linkStyle}>Guidelines</Link>
      </div>
    </div>
  );
}
